<template>
  <div>
    <div class="b-address-container">
      <div class="b-address-container-column">
        <div class="b-address-container__user-details">
          <h3>User details</h3>
          <div>
            <div class="b-address-container__user-details__column">
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data" style="height:unset">
                  <div class="b-address-container__user-details__row-heading">Corresponding address</div>
                  <br />

                  <div v-if="edit.corresponding_address">
                    <input
                      type="text"
                      :value="details.corresponding_address"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_address'})"
                      @blur="edit.corresponding_address=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('corresponding_address',$event)"
                    class="b-personal-container__user-details__text"
                    style="height:unset"
                    :style="{'cursor': details.kyc_form_check_status=='2'|| details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.corresponding_address}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding city</div>
                  <br />

                  <div v-if="edit.corresponding_city">
                    <input
                      type="text"
                      :value="details.corresponding_city"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_city'})"
                      @blur="edit.corresponding_city=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('corresponding_city',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.corresponding_city}}</div>
                </div>
              </div>
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding country</div>
                  <br />

                  <div v-if="edit.corresponding_country">
                    <select
                      :value="details.corresponding_country"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_country'})"
                      @blur="edit.corresponding_country=false"
                    >
                      <option
                        v-for="country in countries"
                        :value="country"
                        :key="country"
                      >{{ country }}</option>
                    </select>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('corresponding_country',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                  >{{details.corresponding_country}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding Pincode</div>
                  <br />

                  <div v-if="edit.corresponding_pincode">
                    <input
                      type="text"
                      :value="details.corresponding_pincode"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_pincode'})"
                      @blur="edit.corresponding_pincode=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('corresponding_pincode',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.corresponding_pincode}}</div>
                </div>
              </div>
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Corresponding State</div>
                  <br />

                  <div v-if="edit.corresponding_state">
                    <template v-if="details.corresponding_country.toUpperCase()==='INDIA'">
                      <select
                      :value="details.corresponding_state"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_state'})"
                      @blur="edit.corresponding_state=false"
                    >
                      <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
                    </select>
                    </template>
                    <template v-else>
                      <input
                      type="text"
                      :value="details.corresponding_state"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'corresponding_state'})"
                      @blur="edit.corresponding_state=false"
                    />
                    </template>
                    
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('corresponding_state',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                  >{{details.corresponding_state}}</div>
                </div>

                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Permenant address</div>
                  <br />

                  <div
                    class="b-personal-container__user-details__text"
                  >Same as corresponding address</div>
                </div>
              </div>
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Documentation Type</div>
                  <br />

                  <div v-if="edit.doctype_poa_corr">
                    <select
                      :value="details.doctype_poa_corr"
                      class="b-personal-container__user-details__data-edit__select"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'doctype_poa_corr'})"
                      @blur="edit.doctype_poa_corr=false"
                    >
                      <option value="passport">Passport</option>
                      <option value="driving_license">Driving License</option>
                      <option value="bank_passbook">Bank Passbook</option>
                      <option value="bank_account_statement">Bank Account Statement</option>
                      <option value="voter_id_card">Voter ID Card</option>
                      <option value="ration_card">Ration Card</option>
                      <option value="registered_sale_agreement">Registered Sale Agreement</option>
                      <option value="telephone_bill">Telephone Bill</option>
                      <option value="electricity_bill">Electricity Bill</option>
                      <option value="gas_bill">Gas Bill</option>
                      <option value="aadhaar">Aadhaar</option>
                    </select>
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('doctype_poa_corr',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.doctype_poa_corr}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Residence Status</div>
                  <br />

                  <div
                    class="b-personal-container__user-details__text"
                  >{{details.residence_status==='resident_individual'?'Residence Individual':'Non Residence Individual'}}</div>
                </div>
              </div>
              <div class="b-address-container__user-details__row">
                <div
                  class="b-address-container__user-details__row-data"
                  v-if="details.doctype_poa_corr=='passport' || details.doctype_poa_corr=='driving_license'"
                >
                  <div
                    class="b-address-container__user-details__row-heading"
                  >Validity of provided address proof</div>
                  <br />

                  <div v-if="edit.validity_doc_poa_corr">
                    <input
                      type="date"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'validity_doc_poa_corr'})"
                      @blur="edit.validity_doc_poa_corr=false"
                      :value="details.validity_doc_poa_corr"
                    />
                    <!-- <DatePicker
                    format="dd MMM yyyy"
                    input-class="b-personal-container__user-details__data-edit"
                    placeholder="Select Validity of address proof"
                    @selected="updateDate"
                    @closed="closedDatePicker"
                    :value="details.validity_doc_poa_corr"
                    :clear-button="true"
                    clear-button-icon="fa fa-times-circle"
                    /> -->
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('validity_doc_poa_corr',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.validity_doc_poa_corr}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--------------NRI Passport Details-------->
        <div
          class="b-address-container__user-details"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <h3>NRI Passport Details</h3>
          <div>
            <div class="b-address-container__user-details__column">
              <div class="b-address-container__user-details__row">
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Passport Number</div>
                  <br />

                  <div v-if="edit.passport_reference_id">
                    <input
                      type="text"
                      :value="details.passport_reference_id"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'passport_reference_id'})"
                      @blur="edit.passport_reference_id=false"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('passport_reference_id',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.passport_reference_id}}</div>
                </div>
                <div class="b-address-container__user-details__row-data">
                  <div class="b-address-container__user-details__row-heading">Validity of passport</div>
                  <br />

                  <div v-if="edit.passport_validity_date">
                    <input
                      type="date"
                      class="b-personal-container__user-details__data-edit"
                      @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'passport_validity_date'})"
                      @blur="edit.passport_validity_date=false"
                      :value="details.passport_validity_date"
                    />
                  </div>
                  <div
                    v-else
                    v-on:dblclick="changeKycDetailHandler('passport_validity_date',$event)"
                    class="b-personal-container__user-details__text"
                    :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                  >{{details.passport_validity_date}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-address-container__form" v-if="details.kyc_form_check_status ==='2' || details.kyc_form_check_status=='6'">
          <div>
            <input
              type="checkbox"
              id="address"
              value="address"
              :checked="checkDetails['address_status']"
              @change="$emit('checkDetail', 'address_status')"
            />
            <label for="address">Address is as per the uploaded document</label>
            <br />
          </div>
        </div>
        <div class="b-address-container__btn">
          <div v-if="editFlag">
            <button class="b-global__button" @click="updateInfo">Save Changes</button>
          </div>
          <button @click="checkEditDetails();" class="b-global__button">NEXT</button>
          <div v-if="showModal">
            <Modal @closeModal="showModal= false" @goNext="$emit('goNext') "></Modal>
          </div>
        </div>
      </div>
      <div class="b-address-container-column">
        <h3>User Proof</h3>
        <div class="b-address-container__img">
          <img
            v-bind:src="details.url_poa_corr_side1"
            alt="Proof of address side 1"
            style="width:100%"
          />

          <div class="b-personal-container__img-section">
            <p>Proof of address side 1</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_poa_corr_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
                <div>
                <button
                  @click="maskImage('url_poa_corr_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >MASK</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poa_corr_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>
        <div class="b-address-container__img">
          <img v-bind:src="details.url_poa_corr_side2" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Proof of address side 2</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_poa_corr_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
                  <div>
                <button
                  @click="maskImage('url_poa_corr_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >MASK</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poa_corr_side2',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="b-address-container__img"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <img v-bind:src="details.url_passport_side1" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Passport image side 1</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_passport_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_passport_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="b-address-container__img"
          v-if="details.residence_status==='non_resident_individual'"
        >
          <img v-bind:src="details.url_passport_side2" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Passport image side 2</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_passport_side2')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_passport_side2',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "../../commons/modal.vue";
import states from "../../commons/states.json";
import countries from "../../commons/countries.json";


import moment from "moment";

export default {
  components: { Modal },
  data() {
    return {
      edit: {
        corresponding_address: false,
        corresponding_city: false,
        corresponding_country: false,
        corresponding_pincode: false,
        residence_status: false,
        corresponding_state: false,
        validity_doc_poa_corr: false,
        doctype_poa_corr: false,
        permanent_address: false,
        permanent_pincode: false,
        permanent_country: false,
        permanent_state: false,
        permanent_city: false,
        passport_validity_date: false,
        passport_reference_id: false
      },
      showModal: false,
      states: states.states,
      countries: countries.countries
    };
  },
  props: {
    checkDetails: {
      type: Object
    },

    details: {
      type: Object,
      required: true
    },
    editFlag: {
      type: Boolean
    }
  },

  methods: {
    checkedNames: function(element) {
      let array = ["Address", element];
      this.$emit("checkedBox", array);
    },
    showEditHandler(value) {
      this.edit[value] = !this.edit[value];
    },
    updateInfo() {
      let obj = {};
      obj.data = this.$store.state.kycDetails.userKycData;
      obj.id = this.$route.params.id;
      if (obj.data.hasOwnProperty("error_message"))
        delete obj.data.error_message;
      this.$store.dispatch("updateKycDetail", obj);
      this.$emit("changeEditFlag", false);
    },
    changeKycDetailHandler(editInfo, event) {
      if (this.details.kyc_form_check_status == "2" || this.details.kyc_form_check_status == "6") {
        this.edit[editInfo] = !this.edit[editInfo];
        this.$emit("changeEditFlag", true);
      } else {
        event.preventDefault();
      }
    },
    checkEditDetails() {
      if (this.editFlag) this.showModal = true;
      else this.$emit("goNext");
    },
    handleUploadFile: function(key, evt) {
      let files = evt.target.files || evt.dataTransfer.files;
     
      this.$store.dispatch("uploadFile", {
        file: files[0],
        id: this.$route.params.id,
        key: key
      });
    },
    rotateImage(element) {
      
      this.$store.commit("setcroppedImgUrl", this.details[element]);
      this.$router.push({
        name: "kyc-details-edit-img",
        params: {
          id: this.$route.params.id,
          imgname: element
        }
      });
    },
    maskImage(element){
           this.$store.commit("setcroppedImgUrl", this.details[element]);
      this.$router.push({
        name: "kyc-details-mask-img",
        params: {
          id: this.$route.params.id,
          imgname: element
        }
      });
    },
      updateDate(date){
        this.$store.commit('updateKycDetail',{value: moment(date).format("DD/MM/YYYY"),key:'validity_doc_poa_corr'})
    },
    closedDatePicker(){
      this.edit.validity_doc_poa_corr=false;
    }
  }
};
</script>

<style scoped>
.b-address-container {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.b-address-container__img {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}

.b-address-container__form button {
  margin-top: 15px;
}
.b-address-container__form {
  margin-top: 25px;
  text-align: center;
}
.b-address-container__error {
  color: #d8000c;
}
.b-address-container__form label {
  margin-left: 15px;
}
.b-address-container__img-label {
  text-align: center;
  margin-top: 10px;
}
.b-address-container__user-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-address-container-column {
  display: flex;
  flex-direction: column;
  margin: 30px;
}
.b-address-container-column h3 {
  display: flex;
  justify-content: center;
}
.b-address-container__user-details__column {
  display: flex;
  flex-direction: column;
}
.b-address-container__user-details__row {
  display: flex;
}
.b-address-container__user-details__row-heading {
  min-width: 275px;
  font-weight: 600;
}

.b-address-container__user-details__row-data {
  padding: 10px;
  width: 328px;
  margin: 10px;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  height: 80px;
}
.edit,
.save {
  width: 15px;
  height: 16px;
  object-fit: contain;
}
.b-address-container__user-details__edit {
  display: flex;
}
.b-address-container__user-details__data {
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  width: 250px;
  text-overflow: ellipsis;
}
.b-address-container__user-details__data-edit {
  width: 100%;
  border: none;
}
.b-address-container__btn {
  display: flex;
  justify-content: center;
}
.b-personal-container__user-details__text {
  height: 18px;
}
.b-personal-container__user-details__data-edit {
  width: 90%;
  font-size: 16px;
  padding: 4px;
}
.b-personal-container__img-section {
  text-align: center;
}
.b-personal-container__upload {
  cursor: pointer;
  position: relative;
  margin-top: 13px;
}
.b-personal-container__upload-input {
  -webkit-appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.b-perosnal-conatiner__upload-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding-left: 10px;
  letter-spacing: normal;
  text-align: center;
  color: #00bfff;
}
.b-personal-container__user-details__data-edit__select {
  border: none;
  background: none;
  font-size: 16px;
  width: 100%;
}
.b-personal-container__edit-btn {
  margin: unset !important;
}
.b-personal-container__btn-container {
  display: flex;
  justify-content: space-evenly;
}
</style>